<div class="messages-page">


  <!-- HEADER -->

  <div class="page-header">

    <h1>
      Messages
    </h1>

    <p>
      Communicate with your customers and manage enquiries.
    </p>

  </div>




  <!-- MESSAGE CONTAINER -->

  <div class="messages-container">



    <!-- LEFT CONVERSATIONS -->

    <div class="conversation-panel">


      <div class="search-box">

        <span class="material-symbols-outlined">
          search
        </span>

        <input
type="text"
placeholder="Search conversations"
[(ngModel)]="searchText"
(input)="searchConversation()">

      </div>





      <div
      class="conversation"
      *ngFor="let chat of filteredConversations"
      (click)="selectConversation(chat)"
      [class.active]="selectedChat?.id === chat.id">


        <div class="avatar">

          {{chat.name.charAt(0)}}

        </div>



        <div class="conversation-info">

          <h3>
            {{chat.name}}
          </h3>


          <p>
            {{chat.lastMessage}}
          </p>

        </div>



        <div class="conversation-meta">

          <span>
            {{chat.time}}
          </span>


          <b
          *ngIf="chat.unread">

            {{chat.unread}}

          </b>


        </div>



      </div>



    </div>





    <!-- CHAT WINDOW -->


    <div class="chat-panel">



      <div class="chat-header">


        <div class="avatar">

          {{selectedChat?.name.charAt(0)}}

        </div>



        <div>

          <h3>
            {{selectedChat?.name}}
          </h3>


          <p>
            Customer
          </p>


        </div>


      </div>





      <div class="chat-body">


        <div
        *ngFor="let msg of messages"
        [class.merchant]="msg.sender==='merchant'"
        [class.customer]="msg.sender==='customer'"
        class="message">


          <div>
  {{msg.text}}
</div>

<div class="message-footer">

<span class="message-time">
 {{msg.time}}
</span>


<span 
class="ticks"
*ngIf="msg.sender==='merchant'">

  <span 
  class="material-symbols-outlined"
  [class.read]="msg.status==='read'">

  done_all

  </span>

</span>

</div>


        </div>
        


      </div>





      <div class="chat-input">


        <input
        type="text"
        placeholder="Type your message..."
        [(ngModel)]="messageText"
        (keyup.enter)="sendMessage()">



        <button
        (click)="sendMessage()">

          <span class="material-symbols-outlined">
            send
          </span>

        </button>


      </div>




    </div>



  </div>



</div>